import { Doughnut } from 'vue-chartjs'
export default {
  extends: Doughnut,
  props: ['data', 'options'],
  watch: {
    data: function () {
      this.$data._chart.destroy()
      this.renderDoughnut()
    }
  },
  computed: {
    chartData: function () {
      return this.data
    }
  },
  methods: {
    renderDoughnut: function () {
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.data, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/Doughnut.js